import { FilterOption } from './combo-box.props.ts';
export class SelectionChangedEvent extends CustomEvent<FilterOption[]> {
    static readonly eventName = 'selection-changed';
    
    constructor(selectedItems: FilterOption[]) {
        super(SelectionChangedEvent.eventName, {
            detail: selectedItems,
            bubbles: true,
            composed: true
        });
    }
}

export class SearchChangedEvent extends CustomEvent<string> {
    static readonly eventName = 'search-changed';

    constructor(searchText: string) {
        super(SearchChangedEvent.eventName, {
            detail: searchText,
            bubbles: true,
            composed: true
        });
    }
}

export class OrderChangedEvent extends CustomEvent<FilterOption[]> {
    static readonly eventName = 'order-changed';

    constructor(orderedItems: FilterOption[]) {
        super(OrderChangedEvent.eventName, {
            detail: orderedItems,
            bubbles: true,
            composed: true
        });
    }
}
